import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { StyledLabel, ErrorText } from './Field';
import { Field } from 'redux-form';
import styled from 'styled-components';
import { CATEGORY_FIELD } from './BaseForm';
import { colors } from 'hui/src/styled/theme';
const SUBCATEGORY_FIELD = 'drilldown_categories';

export const createOption = c => ({
  label: c.parent ? `${c.parent_name} - ${c.name}` : c.name,
  value: `${c.id}|${c.name}`,
  parentValue: c.parent ? `${c.parent_id}|${c.parent_name}` : `${c.id}|${c.name}`,
  ...c
});

const StyledSelect = styled(Select.Creatable)`
  .Select-control {
    border: 1px solid ${colors.GREY};
    height: 42px;
  }

  .Select-placeholder {
    color: ${colors.GREY};
  }

  .Select-placeholder,
  .Select-value,
  .Select-input {
    padding: 0 20px;
    line-height: 40px !important;
  }

  .Select-menu-outer .Select-create-option-placeholder {
    display: none;
  }

  .Select-menu-outer {
    position: relative;
    border: 1px solid ${colors.GREY};
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
`;

const RenderInput = class RenderInput extends Component {
  render() {
    const { input, meta, updateField, onSelectCategory, label, ...rest } = this.props;
    return (
      <div style={{ position: 'relative', marginBottom: '1rem' }}>
        <StyledSelect
          {...input}
          {...rest}
          clearable={false}
          value={input.value}
          innerRef={ref => (this.ref = ref)}
          onBlurResetsInput={false}
          onChange={option => {
            input.onChange(option);
            updateField(SUBCATEGORY_FIELD, null);
            if (option) {
              onSelectCategory(option);
            }
          }}
          onBlur={() => {
            const { value } = input;
            onSelectCategory({ label: value, value });
            this.ref.createNewOption(value);
            input.onBlur(value);
          }}
        />
        <StyledLabel>{label}</StyledLabel>
        {meta.error && meta.touched && <ErrorText>{meta.error}</ErrorText>}
      </div>
    );
  }
};

const CategorySelect = ({ onSelectCategory, categories, updateField, label }) => (
  <div>
    <div style={{ position: 'relative' }}>
      <Field
        name={CATEGORY_FIELD}
        component={RenderInput}
        onSelectCategory={onSelectCategory}
        updateField={updateField}
        label={label}
        options={categories.map(createOption).sort((a, b) => (a.label > b.label ? 1 : -1))}
        placeholder="Type or select a category"
      />
    </div>
  </div>
);

CategorySelect.propTypes = {
  onSelectCategory: PropTypes.func,
  categories: PropTypes.array,
  updateField: PropTypes.func,
  selectedCategory: PropTypes.object,
  label: PropTypes.string
};

CategorySelect.defaultProps = {
  categories: []
};

RenderInput.propTypes = {
  onSelectCategory: PropTypes.func,
  categories: PropTypes.array,
  updateField: PropTypes.func,
  label: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};

export default CategorySelect;
